module.exports = __webpack_public_path__ + "static/media/dashboard_dark.1f881003.svg";